<script setup>
import { computed } from 'vue';

const props = defineProps({
  contact: {
    type: Object,
    default: () => ({}),
  },
});

const attrs = computed(() => props.contact?.custom_attributes || {});

const crmStatus = computed(() => attrs.value.crm_status || null);
const patientId = computed(() => attrs.value.crm_patient_id || null);
const leadId = computed(() => attrs.value.crm_lead_id || null);
const proximaCita = computed(() => attrs.value.proxima_cita || null);

const statusLabel = computed(() => {
  if (crmStatus.value === 'paciente') return 'Paciente';
  if (crmStatus.value === 'lead') return 'Lead';
  return 'No vinculado';
});

const statusClass = computed(() => {
  if (crmStatus.value === 'paciente') return 'bg-green-500 text-white';
  if (crmStatus.value === 'lead') return 'bg-orange-500 text-white';
  return 'bg-slate-300 text-slate-700';
});
</script>

<template>
  <div v-if="crmStatus" class="px-4 py-2 border-b border-slate-100 dark:border-slate-700">
    <div class="flex items-center justify-between mb-1">
      <span class="text-xs font-semibold text-slate-500 uppercase tracking-wide">
        Clínica
      </span>
      <span
        class="inline-flex items-center px-2 py-0.5 rounded text-xs font-medium"
        :class="statusClass"
      >
        {{ statusLabel }}
      </span>
    </div>

    <div v-if="proximaCita" class="text-sm text-slate-700 dark:text-slate-200 mt-1">
      <i class="icon ion-calendar mr-1" />
      Próxima cita: <strong>{{ proximaCita }}</strong>
    </div>

    <div v-if="patientId || leadId" class="mt-2 flex gap-2">
      <a
        :href="`https://crm.globalfeetpanama.com/citas?paciente_id=${patientId || leadId}`"
        target="_blank"
        class="text-xs text-woot-500 hover:text-woot-600 font-medium"
      >
        Ver citas →
      </a>
    </div>
  </div>
</template>
